/* eslint-disable jsx-a11y/anchor-is-valid */
import Aside from "../../components/Sidebar";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import ScrollUp from "../../components/ScrollUp";
import MainTitle from "../../components/MainTitle";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const Articles = () => {
  return (
    <>
      <div className="page d-flex">
        <Aside />
        <div className="content w-full">
          <Header />
          <MainTitle title="المقالات" />
          <div
            className="container-8"
            style={{
              paddingBottom: "60px",
            }}
          >
            <div className="wb-1 m-wb bg-white p-10 m-10">
              <div className="inf inf-2">
                <h3 className="my-h3-2 my-h3">ما هو الجرافيك ديزاين؟</h3>
              </div>
            </div>
            <pre class="my-pre">
              {" "}
              يعني اي جرافيك ديزينر قبل مااقلولك - يعني اية ؟ هقولك هو بيعمل
              اية؟ ================== هحكيلك قصة اكل قصيرة - انت جعان حلو الكلام
              فنزلت السوبر ماركت فلاقيت علبة لبن وعلبة جبنة وكيس شيبسي وكنزاية
              وشيكولاتة كيت كات وروقت ع حالك وفرتكت الفلوس لحد هنا تقولي اي
              علاقة الكلام دا بالجرافيك هقولك ازاي دا الكلام دا هو الي بيعمله
              المصمم جرافيك - هو الي مصمم التصميم الي ع علبة اللبن والجبنة
              والكيت كات ولو بصيت ع اسم المحل هتلاقي البانر دا عامله مصمم الكلام
              دا ينطبق ع جميع المنتجات مش بس كدا بيصمم المواقع وتطبيقات الموبايل
              وبيلم الغسيل 😂 الجرافيك ديزينر أشكال وأنواع Graphic designer دا
              كلمة شاملة مفهوم الجرافيك ديزاين : الجرافيك ديزاين دا جزء مربتط
              بوجود الإنسان ومتلازم معاه ومع كل تطورات حياته , ومعنى كدا ان اي
              حاجة انت بتستخدمها يوميا تدخل الى اطار ال جرافيك ديزاين , كل حاجة
              قدامك ليها شكل محدد وجسم محدد ثابت بيعبر عن هوية الشيئ اللي امامك
              دا وبيديك لمحة عنه حتى لو مش فاهم هو ايه بس اهو بيوصلك معلومة
              معينة . ممكن نقول ان ال جرافيك ديزاين هو طريقة لتبسيط/تسهيل
              المعلومة , بردو هو يعتبر طريقة للإبداع والتفكير بحيث ان اي حاجة
              ممكن تتخيلها تقدر تعملها ديزاين . المصمم ويليام اديسون William
              Addison اول الناس اللي اطلقت عليه جرافيك ديزاين عام 1922م و كان من
              وجهة نظره ان المصمم هو الشخص اللي بيقوم بجمع بين صور ـ كلمات ـ
              ألوان ـ و الدمج و المزج بينهم و المصمم الناجح هو من يمزج الواقع
              بالخيال و يبدع فى التصميم عن مشروعه , طيب كدا عرفرنا ايه هو ال
              جرافيك ديزاين ... الديزاينر بقى ؟ من هو الجرافيك ديزاينر ؟ المصمم
              نفسه بيبقى شخص عنده قدرة على الابداع والتميز عن غيره ويربط الواقع
              بالخيال و بلا بلا بلا... المصمم دا بيبقى شخص واخد فكرة عن حاجات
              كتيرة جداً موجودة في عالم ال جرافيك ديزاين –طبعا مش كل حاجة بس على
              الاقل يكون واخد فكرة كبيرة- وبيكون متخصص في حاجة معينة او اكتر .
              يعني ببساطة المصممين دول هم الناس اللي بيقومو بشغلانة التواصل عن
              طريق العناصر المرئية زي الصور –مع اختلاف انواعها – الخطوط ,
              الاشكال , الالوان , الكلمات ,الظلال ...الخ) ونقدر نعتبرهم فنانين !
              😃 مش اي حد يقدر يقول على نفسه جرافيك ديزاينر , يعني مش اروح
              اشوفلي كورس فوتوشوب على اليوتيوب وابقى جرافيك ديزاينر خلاص واشتغل
              , لا مش كدا خالص , لازم قبل ما تبدأ اي مجال تاخد فكرة كبيرة عنه
              ولازم يبقى عندك المعلومات والخبرات الكافية اللي تخليك تقدر تقول
              على نفسك انا جرافيك ديزانير . غلطة كبيرة معظم المصريين(واغلب
              المبتدئين بشكل عام) بيعملوها وهي انهم يدخلو عاليوتيوب ويعرفو كام
              درس كدا وخلاص بقو مصممين - ==================== التخصصات بقي
              Graphic designer social media بيعمل تصميمات السوشيال ميديا دي
              شغلتي حاليا ---------------------------- Graphic design Branding
              بيعمل لوجوهات وهوية بصرية ---------------------------- Graphic
              design digital printing بيشتغل ف مطبعة ودا غالبا آخره ctrl+P😂 الا
              بقي لو المطبعة عامله قسم للطباعة وقسم للديزينر ودا نادر مابيحصل
              ---------------------------- Web Design..تصميم واجهات المواقع
              ---------------------------- Motion Graphics..تصميم وحركة
              ---------------------------- Animation Graphic.. بيعمل كرتون زي
              سوبر هنيدي كدا 😂 ---------------------------- App Design..تصميم
              واجهات وايقون التطبيقات ---------------------------- Illustration
              design...رسم flat و vector ----------------------------
            </pre>
          </div>
          <ScrollUp />
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Articles;
